// le bus d'événements est un moyen de communiquer entre les différents composants
//   des changements survenant de façon aléatoire
// par exemple, lorsque l'utilisateur change la dimension de la fenêtre du navigateur
//   le module App.vue émet les nouvelles dimensions qui est utilisé
//   par TheFooter.vue pour redimensionner les icônes
//   et par les ConfigXxxxList.vue pour ajuster le nombre de lignes dans la table

import Vue from 'vue'
export default new Vue()
